import { handleActions } from 'redux-actions';
import Immutable from 'immutable';

const MaintenanceSearchState = Immutable.fromJS({
  alertStyle: null,
  alertMessage: null,
  showModal: false,
  search_card: null,
  search_details: [],
  search_prePhotos: [],
  search_postPhotos: [],

  isLoadingChipEpcs: false
});

const maintenanceSearchReducer = handleActions({
  CLEAN_MAINTENANCE_SEARCH_ALERT: (state, { payload }) => {
    return state.merge({
      alertStyle: null,
      alertMessage: null
    })
  },
  OPEN_SEARCH_M_RECORD_MODAL: (state, { payload }) => {
    return state.merge({
      showModal: true
    })
  },
  CLOSE_SEARCH_M_RECORD_MODAL: (state, { payload }) => {
    return state.merge({
      showModal: false
    })
  },
  FIND_SEARCH_M_RECORD_DETAIL: (state, { payload }) => {
    return state.merge({
      search_card: payload.data.card,
      search_details: payload.data.details,
      search_prePhotos: payload.data.prePhotos,
      search_postPhotos: payload.data.postPhotos
    })
  },
  LOADING_SEARCH_CHIP_EPCS: (state, { payload }) => {
    return state.merge({
      isLoadingChipEpcs: true,
    })
  },
  FIND_SEARCH_EPC_LIST: (state, { payload }) => {
    return state.merge({
      isLoadingChipEpcs: false,
    })
  }
}, MaintenanceSearchState);

export default maintenanceSearchReducer;


// WEBPACK FOOTER //
// ./src/reducers/maintenanceSearchReducer.js